<script setup>
import { defineModel, defineProps } from "vue";
const status = defineModel();
const props = defineProps({
  title: String,
});
</script>

<template>
  <v-sheet
    rounded="lg"
    elevation="1"
    class="ma-1 mx-0 pa-0 d-flex align-center"
    min-height="60"
  >
    <template v-if="status === 'OK' || status === 'Error'">
      <template v-if="status === 'OK'">
        <v-icon color="green" class="mr-2 ml-3">mdi-check-circle</v-icon>
      </template>
      <template v-else-if="status === 'Error'">
        <v-icon color="red" class="mr-2 ml-3">mdi-close-circle</v-icon>
      </template>
    </template>
    <template v-else>
      <v-progress-circular
        indeterminate
        color="primary"
        class="mr-2 ml-3"
      ></v-progress-circular>
    </template>
    <span>{{ props.title }} {{ status }}</span>
  </v-sheet>
</template>
